module.exports = __webpack_public_path__ + "static/media/menu_burger.819d9a50.svg";